//https://swiperjs.com/
import Swiper from 'swiper';
import {Navigation, Pagination, EffectFade, Parallax, A11y, Autoplay} from 'swiper/modules';

//import swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import 'swiper/css/parallax';
import 'swiper/css/a11y';

const testimonialSlideshow = document.querySelector('.js-testimonial-slideshow');

if( testimonialSlideshow ){
    //TESTIMONIAL SLIDESHOW
    const mainSwiper = new Swiper(testimonialSlideshow, {
        modules: [EffectFade,Pagination,Parallax,A11y,Autoplay],
        effect: 'fade',
        loop: true,
        speed: 1000,
        autoplay: {
            delay: 5000,
            disableOnInteraction: true,
        },
        parallax: true,
        a11y: {
            enabled: true,
            slideLabelMessage: 'Slide {{index}} of {{slidesLength}}',
        },
        pagination: {
            el: testimonialSlideshow.querySelector('.swiper-pagination'),
            type: 'bullets',
            hideOnclick: false,
            clickable: true
        }
    });
}